import PropTypes from 'prop-types';
import { Controller, useFormContext } from 'react-hook-form';
import { Box, Typography } from '@mui/material';
import { LocalizationProvider, DateTimePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

function RHFDateTimePicker({ name, label }) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { value, onChange }, fieldState: { error } }) => (
        <DateTimePicker
          label={label}
          value={value}
          onChange={onChange}
          slotProps={{
            textField: {
              fullWidth: true,
              error: !!error,
              helperText: error?.message,
            },
          }}
        />
      )}
    />
  );
}

export default function CampaignDateTimeUpdateCard() {
  return (
    <Box
      sx={{
        mt: 2,
        p: 3,
        borderRadius: 1,
        border: (theme) => `1px solid ${theme.palette.divider}`,
        display: 'flex',
        flexDirection: 'column',
        gap: 3,
      }}
    >
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        {/* Section 1 — Campaign Summary Time */}
        <Box>
          <Typography variant="subtitle1" sx={{ mb: 2 }}>
            Campaign Start Time
          </Typography>
          <Box sx={{ maxWidth: 400 }}>
            <RHFDateTimePicker name="campaignDateTime" label="Campaign Start Date & Time" />
          </Box>
        </Box>

        {/* Divider */}
        <Box sx={{ borderTop: (theme) => `1px solid ${theme.palette.divider}` }} />

        {/* Section 2 — Message Submission & Delivery Time */}
        <Box>
          <Typography variant="subtitle1" sx={{ mb: 2 }}>
            Message Submission & Delivery Time
          </Typography>
          <Box sx={{ display: 'flex', gap: 2 }}>
            <Box sx={{ flex: 1 }}>
              <RHFDateTimePicker name="messageSendTime" label="Message Send / Submission Time" />
            </Box>
            <Box sx={{ flex: 1 }}>
              <RHFDateTimePicker name="deliveryTime" label="Delivery Report (DLR) Time" />
            </Box>
          </Box>
        </Box>
      </LocalizationProvider>
    </Box>
  );
}

CampaignDateTimeUpdateCard.propTypes = {};
RHFDateTimePicker.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
};
